// extracted by css-extract-rspack-plugin
export default {"page":"T7oej","content":"l3FLt","cardContent":"RtHQ0"};